import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsQuasarComponent } from './simple-icons-quasar.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsQuasarComponent ],
    exports:      [ SimpleIconsQuasarComponent ],
    bootstrap:    []
})
export class SimpleIconsQuasarModule {}
